import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=b39240f0&scoped=true"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=b39240f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39240f0",
  null
  
)

export default component.exports